/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import moment from 'moment/moment'
import AdvancedFilters from '../AdvancedFilters'
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat'
import { isProviderACompany } from '../../../services/Provider/Provider.service'
import React, { useEffect } from 'react'
import useUser from '../../Shared/UserProvider/useUser'
import { Form } from 'semantic-ui-react'

const defaultFrom = moment().subtract(7, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
const defaultTo = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')

const Filters = ({children}) => {
    const {user} = useUser()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const from = new URLSearchParams(searchParams).get('from')
    const to = new URLSearchParams(searchParams).get('to')

    useEffect(() => {
        if (!from || !to) {
            const params = new URLSearchParams()
            params.append('from', defaultFrom)
            params.append('to', defaultTo)
            setSearchParams(params, {replace: true})
        }
    }, [from, to, setSearchParams])

    const selectedPosIds = searchParams.get('posIds') ? searchParams.get('posIds').split(',') : []

    const currentFilters = {
        posIds: selectedPosIds,
        dateRange: {
            minDate: moment().subtract(3, 'month'),
            maxDate: moment(),
            startDate: moment(from || defaultFrom).startOf('day'),
            endDate: moment(to || defaultTo).endOf('day'),
        },
    }

    return (
      <AdvancedFilters
        filters={currentFilters}
        onFiltersChange={(filters) => {
            const params = new URLSearchParams()
            if (filters.dateRange.startDate) {
                params.append('from', filters.dateRange.startDate.clone().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'))
            }
            if (filters.dateRange.endDate) {
                params.append('to', filters.dateRange.endDate.clone().endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ'))
            }

            if (filters.posIds.length > 0) {
                params.append('posIds', filters.posIds.join(','))
            }

            navigate({search: params.toString()})
        }}
      >
          <div css={css`
              display: block;
              width: 100%;
          `}>
              <AdvancedFilters.DateRangeFilter/>
          </div>

          <div css={css`
              display: block;
              width: 100%;
              margin-bottom: 1rem;
          `}>
              {children}
          </div>

          {(isProviderACompany(user?.provider) || user.isLoggedInOwnScope) &&
            <Form css={css` display: flex;`}>
                <Form.Group widths="equal">
                    <AdvancedFilters.MultiPosFilter/>
                </Form.Group>
            </Form>
          }

      </AdvancedFilters>
    )
}

export { Filters }
